export const actionTypes = {
  EXPORT_EXTERNAL_COLLECTION_REPORT_LOADING: 'EXPORT_EXTERNAL_COLLECTION_REPORT_LOADING',
  EXPORT_EXTERNAL_COLLECTION_REPORT: 'EXPORT_EXTERNAL_COLLECTION_REPORT',
  RESET_EXTERNAL_COLLECTION_EXPORT_SUCCESS: 'RESET_EXTERNAL_COLLECTION_EXPORT_SUCCESS',

  EXPORT_EXTERNAL_COLLECTION_ITEM_REPORT_LOADING: 'EXPORT_EXTERNAL_COLLECTION_REPORT_LOADING',
  EXPORT_EXTERNAL_COLLECTION_ITEM_REPORT: 'EXPORT_EXTERNAL_COLLECTION_REPORT',
  RESET_EXTERNAL_COLLECTION_ITEM_EXPORT_SUCCESS: 'RESET_EXTERNAL_COLLECTION_EXPORT_SUCCESS',
};
